import React, { useEffect, useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Typography,
} from "@mui/material";
import {
    makeGETRequestOnUserService,
} from "../../Api/api";
import CircularProgress from "@mui/material/CircularProgress";
import InvestorProfileEdit from "./InvestorProfileEdit";
import KYCFormDetails from "./KYCFormDetails";
import MandateDetails from "./MandateDetails";
import PaymentDetails from "./PaymentDetails";
import PreVerificationDetails from "./PreVerificationDetails";


const TabPanel = ({ children, value, index }: any) => {
    return value === index ? <Box sx={{ p: 2 }}>{children}</Box> : null;
};

const a11yProps = (index: number) => ({
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
});

const InvestorProfileDetails = ({ data }: { data: any }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [value, setValue] = useState(0);
    const [loadingInvestorProfile, setLoadingInvestorProfile] = useState(true);
    const [investorProfile, setInvestorProfile] = useState<any>({});
    const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");
    const adminName = loginUser?.name || "";
    const toastr = require("toastr");
    const userUUID = data.user

    const fetchCurrentInvestorProfile = async () => {
        if (!userUUID) return;
        try {
            setLoadingInvestorProfile(true);
            const resp = await makeGETRequestOnUserService(
                `/mutual_fund/get_investor_profile/${userUUID}/`
            );
            if (resp.status === 200) {
                setInvestorProfile(resp.data.data);
            }
        } catch (err) {
            console.error(err);
            toastr.error("Failed to load KYC data");
        } finally {
            setLoadingInvestorProfile(false);
        }
    };

    useEffect(() => {
        fetchCurrentInvestorProfile();
    }, [userUUID]);

    const handleTabChange = (_: any, newValue: number) => setActiveTab(newValue);
    const handleChange = (_: any, newValue: number) => setValue(newValue);

    const SectionLoader = () => (
        <Box
            sx={{
                height: 300,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 1
            }}
        >
            <CircularProgress sx={{ color: "#262349" }} />
            <Typography variant="body2" color="text.secondary">
                Loading...
            </Typography>
        </Box>
    );

    const getErrorMessage = (err: any) => {
        if (err?.response?.data) {
            if (typeof err.response.data === "string") return err.response.data;

            if (err.response.data.error) return err.response.data.error;

            if (err.response.data.non_field_errors) {
                return err.response.data.non_field_errors[0];
            }

            return JSON.stringify(err.response.data);
        }

        return "Something went wrong";
    };

    if (!data) return <div>No data available</div>;

    return (
        <Box sx={{ height: "100vh", overflowY: "auto" }}>

            <Box sx={{ backgroundColor: "#262349", borderBottom: "1px solid rgba(255,255,255,0.2)" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    TabIndicatorProps={{
                        style: {
                            backgroundColor: "#fff",
                            height: 3
                        }
                    }}
                    sx={{
                        minHeight: 48,
                        "& .MuiTab-root": {
                            color: "rgba(255,255,255,0.7)",
                            textTransform: "none",
                        },
                        "& .MuiTab-root.Mui-selected": {
                            color: "#fff !important",
                        }
                    }}
                >
                    <Tab label="Investor Profile Details" />
                    <Tab label="Pre-Verification Details" />
                    <Tab label="KYC Form Details" />
                    <Tab label="Mandates Details" />
                    <Tab label="Payment Details" />
                </Tabs>
            </Box>

            <Box sx={{ p: 2 }}>
                {activeTab === 0 && (
                    loadingInvestorProfile ? (
                        <Box
                            sx={{
                                height: 400,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                gap: 2,
                            }}
                        >
                            <CircularProgress sx={{ color: "#262349" }} />
                            <Typography color="text.secondary">
                                Loading Investor Profile...
                            </Typography>
                        </Box>
                    ) : (
                        <Box>
                            <InvestorProfileEdit
                                data={investorProfile}
                                onBankUpdateSuccess={fetchCurrentInvestorProfile}
                                onAddressUpdateSuccess={fetchCurrentInvestorProfile}
                                onDematUpdateSuccess={fetchCurrentInvestorProfile}
                                onContactUpdateSuccess={fetchCurrentInvestorProfile}
                                onOverseasAddressUpdateSuccess={fetchCurrentInvestorProfile}
                                onNomineeUpdateSuccess={fetchCurrentInvestorProfile}
                            />
                        </Box>
                    )
                )}

                {activeTab === 1 && (
                    <Box>
                        <PreVerificationDetails userUUID={userUUID} />
                    </Box>
                )}

                {activeTab === 2 && (
                    <Box>
                        <KYCFormDetails userUUID={userUUID} />
                    </Box>
                )}

                {activeTab === 3 && (
                    <MandateDetails
                        bankOldId={investorProfile?.bank_old_id}
                    />
                )}

                {activeTab === 4 && (
                    <PaymentDetails
                        userUUID={userUUID}
                    />
                )}
            </Box>
        </Box >

    );
};

export default InvestorProfileDetails;